export const compute_data_root_fields = `
    translations
    session_information {
      balance
      lang
      locale
      communication_token
      session_duration
      session_theme
      validate_domain
      variable1
      variable2
      variable3
      cid
      amount
      currency
      gateway
      payment_method
      order_id
      valid_domains
      transaction_type
      frontend_name
      agent_name
      intent
      session_type
      submit_action
      __typename
    }
    application_configuration {
      encrypt_cashier_css_class_names
      powerslide_autoredirect_time
      currency_sign_amount
      polling_attempts
      enable_transaction_status_polling
      enable_session_events
      promocode
      new_window_size
      dod_acknowledgement_required
      send_get_available_gateways_request
      is_bdcc_enabled
      is_bdcc_window
      is_new_window_mobile
      remove_customer_data
      request_email
      request_phone
      cc_form_provider
      remove_cancel_option_partial_approved
      hide_back_button
      strip_cardholder_accents
      enforce_excluded_card_brands
      change_amount_during_card_cascading
      __typename
    }
    ui_presets {
      theme
      customization_settings {
        appearance
        button_style
        brand_colors_dark
        brand_colors_light
        brand_text_colors_dark
        brand_text_colors_light
        font
        submit_button_type
        submit_button_text_pay_in
        submit_button_text_pay_out
        layout
        amount_field_type
        currency_display_format
        payment_methods_view
        render_typ_image
        preselect_first_payment_method
        preselect_only_available_method
        show_decline_reason_typ
        show_both_currency_limits
        show_default_cardholder_on_pano
        show_transaction_date
        show_transaction_fees
        show_payment_method_fees
        show_payment_method_limits
        show_total_amount
        show_bonus_received
        show_payment_instrument
        show_balance
        show_billing_descriptor
        input_field_style
        payment_instrument_display
        payment_instrument_component_style
        show_card_expiry
        header_style
        promocode
        promocode_configuration {
          enabled
          type
        }
        quick_amount_options {
          enabled
          type
          configuration
        }
        policies_data {
          render_policies_data
          support_website
          support_email
          support_phone
          privacy_policy_url
          terms_of_service_url
          __typename
        }
        last_used_method_first
        currency_display_mode
        show_validation_below_fields
        billing_information_separate_page
        payment_instrument_display
        allow_payment_instrument_removal
        show_instrument_removal_confirmation_modal
        show_back_button
        show_close_button
        __typename
      }
      billing_info_settings {
        country
        customer_name
        email
        phone
        zip
        state
        city
        address
        __typename
      }
      __typename
    }
`;

export const get_compute_data_query = `
  query Get_compute_data {${compute_data_root_fields}}
`;
